<template>
  <div class="sidemenu-slideout-menu" @click="closeMenu">
    <div class="sidemenu-content">
      <div class="close-side-bar">
        <svgicon name="cancelblack" width="15" height="15" :original="true" />
      </div>
      <div class="menu-profile">
        <div v-if="currentClient.logo_buffer" class="logo-client mb-10" @click="gotoProfile"><img :src="getClientLogo()" alt="" class="pointer" /></div>
        <div v-else @click="gotoProfile" class="menu-profile-icon">{{currentUser.name[0]}}</div>
        <div class="menu-profile-name">{{currentUser.name}}</div>
        <div class="menu-profile-name">{{currentUser.role.name}}</div>
        <div class="menu-profile-log-out">
          <a href="javascript:void(0)" @click="logout">
            LOG OUT
          </a>
        </div>
      </div>

  <ul>
    <li v-permission="['view_dashboard']"
        @click="$emit('close'); $addGAEvent('Dashboard', 'click', 'Dashboard Menu');"
        class="sidemenu-slideout-menu-item">
      <router-link :to="{ name: 'Dashboard'}">
        <svgicon name="dashboard"
          class="dropdown-icon" width="20"
           height="20" :original="true" /> DASHBOARD
      </router-link>
    </li>
    <li v-if="$hasFeature('insight_tower') && $hasPermission('view_insight_tower')"
      @click="$emit('close')"
      class="sidemenu-slideout-menu-item">
      <router-link :to="{ name: 'InsightTower'}">
        <svgicon name="icon-menu-exim"
          class="dropdown-icon" width="20"
          height="20" :original="true" />
          INSIGHTS TOWER
      </router-link>
    </li>
    <li v-if="$hasFeature('track_trace') && $hasPermission('view_tracking_menu')"
        @click="$emit('close')"
        class="sidemenu-slideout-menu-item">
      <router-link :to="{ name: tracking}">
        <svgicon name="tracking"
          class="dropdown-icon" width="15"
           height="20" :original="true" /> TRACKING
      </router-link>
    </li>
    <li v-permission="['view_consignee', 'view_user', 'view_depot',
      'view_bucc', 'view_contract',
      'view_detention', 'view_material', 'view_rate_matrix', 'view_vehicle', 'exceptions']"
      @click="$emit('close')"
      class="sidemenu-slideout-menu-item">
      <router-link :to="{ name: 'MDM'}">
        <svgicon name="data"
          class="dropdown-icon" width="20"
          height="20" :original="true" /> DATA MANAGER
      </router-link>
    </li>
    <!-- <li class="sidemenu-slideout-menu-item">
      <a href="javascript:void(0)">
        <svgicon name="contract"
          class="dropdown-icon" width="20"
          height="20" :original="true" /> Contract
      </a>
    </li> -->
    <li v-permission="['optimized_indent']"
        @click="$emit('close')"
        class="sidemenu-slideout-menu-item">
      <router-link :to="optimaRoute">
        <svgicon name="optimize"
          class="dropdown-icon" width="20"
          height="20" :original="true" /> Optima
        </router-link>
    </li>
    <li v-if="$hasFeature('return_management') &&
        ($hasPermission('create_return_deliveries') || $hasPermission('approve_return_requests'))"
        @click="$emit('close')"
        class="sidemenu-slideout-menu-item">
      <router-link :to="planningLandingScreen">
        <svgicon name="contract"
          class="dropdown-icon" width="20"
          height="20" :original="true" /> {{$t('PLANNING')}}
        </router-link>
    </li>
    <li v-if="$hasPermission('view_payment_settlement') && $hasFeature('return_management')"
        @click="$emit('close')"
        class="sidemenu-slideout-menu-item">
      <router-link :to="{ name: 'Pay-Settlement'}">
        <svgicon name="pay"
          class="dropdown-icon" width="20"
          height="20" :original="true" />
          {{ $t('PAYMENT_SETTLEMENT') }}
      </router-link>
    </li>
    <li v-permission="['view_integration_log']"
        @click="$emit('close')"
        class="sidemenu-slideout-menu-item">
      <router-link :to="{ name: 'integrations'}">
        <svgicon name="icon-integrations"
          class="dropdown-icon" width="20"
          height="20" :original="true" /> {{ $t('INDENT_INTEGRATION_HEADER') }}
        </router-link>
    </li>
    <li v-permission="['view_indent']" @click="$emit('close')" class="sidemenu-slideout-menu-item">
      <router-link :to="routeToIndentsNewPath">
        <svgicon name="orders"
          class="dropdown-icon" width="20"
          height="20" :original="true" /> Indents
      </router-link>
    </li>
    <li v-permission="['view_exim']" class="sidemenu-slideout-menu-item">
      <router-link :to="{ name: 'EximMasterIndent'}">
        <svgicon name="icon-menu-exim"
          class="dropdown-icon" width="20"
          height="20" :original="true" />
        <span class="menu-item">Ex-Im</span>
      </router-link>
    </li>
    <li v-if="$hasPermission('view_procure') && $hasFeature('procure')"
      class="sidemenu-slideout-menu-item" @click="$emit('close')">
      <router-link :to="{ name: 'RedirectPage', query: { procureServiceUrl }}">
        <svgicon name="contract"
          class="dropdown-icon" width="17"
          height="20" :original="true" />
        <span class="menu-item">Procure</span>
      </router-link>
    </li>
    <!-- For marico pay v1 v2 comparison -->
    <li v-permission="['view_invoice']" @click="$emit('close')" class="sidemenu-slideout-menu-item"
      v-if="configurations.pay_v1_v2">
      <router-link :to="{ name: 'Invoice'}">
        <svgicon name="pay"
          class="dropdown-icon" width="20"
          height="20" :original="true" />
        <span class="menu-item">Pay-Primary</span>
      </router-link>
    </li>
    <li v-permission="['view_invoice']" @click="$emit('close')" class="sidemenu-slideout-menu-item"
      v-if="configurations.pay_v1_v2">
      <router-link :to="{ name: 'Invoices'}">
        <svgicon name="pay"
          class="dropdown-icon" width="20"
          height="20" :original="true" />
        <span class="menu-item">Pay-Secondary</span>
      </router-link>
    </li>
    <li v-permission="['view_invoice', 'view_wallet']" @click="$emit('close')" class="sidemenu-slideout-menu-item"
      v-else>
      <router-link :to="{ name: paySection}">
        <svgicon name="pay"
          class="dropdown-icon" width="20"
          height="20" :original="true" />
        <span class="menu-item">Pay</span>
      </router-link>
    </li>
    <li v-if="configurations.payment_settings && configurations.payment_settings.deprecate_pay_v1" @click="$emit('close')" class="sidemenu-slideout-menu-item">
      <router-link :to="{ name: 'Invoice'}">
        <svgicon name="pay"
          class="dropdown-icon" width="20"
          height="20" :original="true" />
        <span class="menu-item">Pay V1 (deprecated)</span>
      </router-link>
    </li>
    <li v-if="$hasFeature('report_v2')" v-permission="['view_reports']"
        @click="$emit('close')"
        class="sidemenu-slideout-menu-item">
      <router-link :to="{ name: 'reportsV2'}">
        <svgicon name="reports"
                 class="dropdown-icon" width="20"
                 height="20" :original="true" /> Reports
      </router-link>
    </li>
    <li v-else v-permission="['view_reports']"
        @click="$emit('close')"
        class="sidemenu-slideout-menu-item">
      <router-link :to="{ name: 'reports'}">
        <svgicon name="reports"
          class="dropdown-icon" width="20"
           height="20" :original="true" /> Reports
      </router-link>
    </li>
    <li v-if="$hasFeature('sidebar_pando_agents')" v-permission="['view_pando_agents']"
        @click="$emit('close')"
        class="sidemenu-slideout-menu-item">
      <a href="/pas/">
        <svgicon name="pando-agents" width="20" height="20" :original="true" /> Pando Agents
      </a>
    </li>
    <li v-permission="adminPermissions"
      class="sidemenu-slideout-menu-item">
      <router-link :to="{ name: 'Admin'}">
        <svgicon name="setting"
          class="dropdown-icon" width="20"
          height="20" :original="true" />
        <span class="menu-item">ADMIN</span>
      </router-link>
    </li>
    <li
      class="sidemenu-slideout-menu-item"
      v-if="$hasFeature('riq_v2')"
      >
      <router-link :to="{ name: 'RIQ'}">
        <svgicon name="icon-menu-exim"
          class="dropdown-icon" width="20"
          height="20" :original="true" />
        <span class="menu-item">RATE INTELLIGENCE (RIQ)</span>
      </router-link>
    </li>
    <li
      class="sidemenu-slideout-menu-item"
      v-if="$hasFeature('view_ratelookup')"
      >
      <router-link :to="{ name: 'RateLookUp'}">
        <svgicon name="icon-menu-exim"
          class="dropdown-icon" width="20"
          height="20" :original="true" />
        <span class="menu-item">RATE INTELLIGENCE (Legacy)</span>
      </router-link>
    </li>
    <li
      v-if="$hasFeature('shipment_workflow')" v-permission="['view_shipment_workflow']"
      @click="$emit('close')"
      class="sidemenu-slideout-menu-item">
      <router-link :to="{ name: 'ShipmentWorkflow'}">
        <svgicon name="setting"
          class="dropdown-icon" width="20"
          height="20" :original="true" /> Workflow
      </router-link>
    </li>
   <li v-permission="['view_pack']" class="sidemenu-slideout-menu-item" @click="$emit('close')">
      <router-link :to="{ name: 'RedirectPage', query: { serviceUrl }}">
        <svgicon name="icon-pack"
          class="dropdown-icon" width="20"
          height="20" :original="true" />
        <span class="menu-item">PACK</span>
      </router-link>
    </li>
     <li v-permission="['view_marauders']"
      class="sidemenu-slideout-menu-item" @click="$emit('close')">
      <router-link :to="{ name: 'RedirectPage', query: { serviceUrl: maraudersServiceUrl }}">
        <svgicon name="icon-lms"
          class="dropdown-icon" width="20"
          height="20" :original="true" />
        <span class="menu-item">LMS</span>
        </router-link>
    </li>
    <li v-if="$hasFeature('control_tower')" v-permission="['view_control_tower']"
      class="sidemenu-slideout-menu-item" @click="$emit('close')">
      <router-link :to="{ name: 'RedirectPage', query: { serviceUrl: serviceUrlCT }}">
        <svgicon name="icon-menu-exim"
          class="dropdown-icon" width="20"
          height="20" :original="true" />
        <span class="menu-item">Control-Tower</span>
      </router-link>
    </li>
    <li v-if="$hasPermission('view_order_hub')" v-permission="['view_order_hub']"
      class="sidemenu-slideout-menu-item" @click="$emit('close')">
      <router-link :to="{ name: 'RedirectPage', query: { serviceUrl: serviceUrlOHub }}">
        <svgicon name="icon-menu-exim"
          class="dropdown-icon" width="20"
          height="20" :original="true" />
        <span class="menu-item">Order Hub</span>
      </router-link>
    </li>
    <li v-if="$hasFeature('freight_audit_process')" v-permission="['view_freight_audit_process']"
      class="sidemenu-slideout-menu-item" @click="$emit('close')">
      <router-link :to="{ name: 'RedirectPage', query: { serviceUrl: serviceUrlFAP }}">
        <svgicon name="icon-menu-exim"
          class="dropdown-icon" width="20"
          height="20" :original="true" />
        <span class="menu-item">FAP</span>
      </router-link>
    </li>
  </ul>
</div>
</div>
</template>
<script type="text/javascript">
import { mapGetters } from 'vuex';
import { adminPermissions } from '@/constants/admin';

export default {
  data() {
    return {
      isOpen: false,
      adminPermissions,
    };
  },
  computed: {
    ...mapGetters({
      configurations: 'app/configurations',
      currentUser: 'app/currentUser',
      currentClient: 'app/currentClient',
    }),
    planningLandingScreen() {
      if (this.$hasPermission('create_return_deliveries')) {
        return { name: 'Deliveries' };
      }
      if (this.$hasPermission('approve_return_requests')) {
        return { name: 'ReturnRequest' };
      }
      return {};
    },
    serviceUrl() {
      let url = window.location.host;
      const index = url.indexOf('.');
      url = (index !== -1) ? `${url.substring(0, index)}-pack${url.substring(index, url.length)}` : url;
      return url;
    },
    procureServiceUrl() {
      let url = window.location.host;
      url = `${url}/procure/`;
      return url;
    },
    serviceUrlCT() {
      let url = window.location.host;
      const index = url.indexOf('.');
      url = (index !== -1) ? `${url.substring(0, index)}-ct${url.substring(index, url.length)}` : url;
      return url;
    },
    serviceUrlOHub() {
      let url = window.location.host;
      const index = url.indexOf('.');
      url = (index !== -1) ? `${url.substring(0, index)}-ohub${url.substring(index, url.length)}` : url;
      return url;
    },
    serviceUrlFAP() {
      let url = window.location.host;
      const index = url.indexOf('.');
      url = (index !== -1) ? `${url.substring(0, index)}-fap${url.substring(index, url.length)}` : url;
      return url;
    },
    maraudersServiceUrl() {
      let url = window.location.host;
      const index = url.indexOf('.');
      url = (index !== -1) ? `${url.substring(0, index)}-lms${url.substring(index, url.length)}` : url;
      return url;
    },
    tracking() {
      let section = '';
      if (this.$hasPermission('view_trips')) {
        section = 'Trips';
      } else if (this.$hasPermission('view_track_dashboard')) {
        section = 'TrackDashboard';
      } else if (this.$hasPermission('view_map')) {
        section = 'Map View';
      } else if (this.$hasPermission('view_rejections')) {
        section = 'Rejections';
      }
      return section;
    },
    rateLookUp() {
      const section = 'Rate Lookup';
      return section;
    },
    paySection() {
      let section = '';
      // Hiding this page because no client use it, will add back if required
      // if (this.$hasFeature('pay_indents')) {
      //   section = 'Pay Indents';
      // } else
      if (this.$hasFeature('payments_v2')) {
        if (this.$hasPermission('view_invoice')) {
          section = 'Invoices';
        } else {
          section = 'Wallet-v2';
        }
      } else {
        section = 'Invoice';
      }
      return section;
    },
    routeToIndentsNewPath() {
      return { name: 'OutboundIndentsV2' };
    },
    optimaRoute() {
      return this.$hasFeature('hide_optima_output_listing')
        ? { name: 'Optima Input' }
        : { name: 'Optima' };
    },
  },
  methods: {
    getClientLogo() {
      return this.currentClient.logo_buffer;
    },
    closeMenu() {
      this.$emit('close');
    },
    gotoProfile() {
      this.$router.push({ name: 'Profile' });
    },
    async logout() {
      if (this.$hasPermission('view_support_widget')) {
        // remove the widget
        const freshWidget = window.FreshWidget;
        if (window.FreshWidget) {
          window.FreshWidget.destroy();
          window.FreshWidget = freshWidget;
        }
      }
      const optimaHeaders = localStorage.getItem('Optima-selected-headers');
      const optimaInputPageHeaders = localStorage.getItem('optima-input-selected-headers');
      await this.$store.dispatch('app/logout',{ data: { } });
      const tableParameters = localStorage.getItem('tableParameters');
      localStorage.clear();
      if (tableParameters) {
        localStorage.setItem('tableParameters', tableParameters);
      }
      if (optimaHeaders) {
        localStorage.setItem('Optima-selected-headers', optimaHeaders);
      }
      if (optimaInputPageHeaders) {
        localStorage.setItem('optima-input-selected-headers', optimaInputPageHeaders);
      }
      localStorage.setItem('tsm-user-token', '');
      const result = await this.$store.dispatch('app/ssoCheck');
      if (result.status === 404) {
        this.$router.push({ name: 'Login' });
      } else {
        this.$router.push({ name: 'SSOLogin' });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.close-side-bar {
    position: relative;
    top: -8px;
    left: 48px;
    cursor: pointer;
}
</style>
